import { mutatorAction } from "satcheljs";
import { ScheduleOverViewType } from "sh-models";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

/**
 * Sets the schedule overview type of the Schedules page. (People/Shifts view)
 */
export default mutatorAction("SET_SCHEDULE_OVERVIEW_TYPE",
    function setScheduleOverViewType(viewState: SchedulesViewStateStore | IPreviewSchedulePageStore, newScheduleOverViewType: ScheduleOverViewType) {
        viewState.scheduleOverViewType = newScheduleOverViewType;
    }
);